import {
    SET_SGIP_VALUE,
    SET_SGIP_TOGGLE,
} from './constants';

const defaultState = {
    sgipValue: 0,
    sgipToggle: true,
};

const sgip = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SGIP_VALUE:
            return { ...state, sgipValue: action.sgipValue };

        case SET_SGIP_TOGGLE:
            return { ...state, sgipToggle: action.sgipToggle };

        default:
            return state;
    }
};

export default sgip;



// WEBPACK FOOTER //
// ./src/containers/common/sgip/reducer.js